export interface FinancialCalendar {
  id: number;
  calendarCode: string;
  date: string;
  description?: string | null;
  type: CalendarType;
}

export enum CalendarType {
  SETTLEMENT = 'settlementCalendar',
  TRADING = 'tradingCalendar',
}
